import { render } from "./MyReport.vue?vue&type=template&id=3453ab50"
import script from "./MyReport.vue?vue&type=script&lang=js"
export * from "./MyReport.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__